import { createFileRoute } from '@tanstack/react-router';
import { PersonasListPage } from '@/pages/personas/PersonasListPage';

export const Route = createFileRoute('/personas/')({
  component: PersonasListPage,
});
